// extracted by mini-css-extract-plugin
module.exports = {"termsNConditionsContent":"TermsAndConditions_termsNConditionsContent__3icqy","textJustify":"TermsAndConditions_textJustify__29eYE"};